import useRequest from '@/websdk/utils/request';
export default (function () {
  const { isRequestSuccessed, exec } = useRequest({
    url: '/api/inspection/method',
    name: 'inspectionMethodPOST',
    method: 'POST',
  });
  return [isRequestSuccessed, exec];
});
